<template>
  <div :ref="ref" :class="'radio_container' + (noChange ? ' no_hover' : '')">
    <div :class="'round'">
      <label :style="'background-color: ' + selected_color"/>
    </div>
    <div v-if="!noChange" class="options_anchor">
      <div :class="'options_container'" :style="(offset_left ? `left:${offset_left}` : '')">
        <ul>
          <li
              v-for="(item, index) in items"
              :key="index"
              :class="(selected == item.value ? 'selected' : '') "
              @click="select(id, item.value)"
          >
            <div :class="'round'">
              <label :style="'background-color: ' + item.color" />
            </div>
            <span>{{ item.label }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ColorRadioV2",
  props: {
    id: String,
    selected: Number,
    items: Object,
    callback: Function,
    offset_left: String,
    noChange:Boolean
  },
  data() {
    return {
      ref: 'r_check_' + Math.random().toString(),
      selected_color: 'white'
    }
  },
  mounted() {
    let selected_item = this.items.filter((item) => {
      return item.value == this.selected;
    });

    if (selected_item.length) {
      this.selected_color = selected_item[0].color;
    }
  },
  methods: {
    select(id, value) {
      if (this.callback) {
        this.callback(id, value);
      }
    }
  }
}
</script>

<style scoped>

.radio_container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 8px;
}

.round {
  position: relative;
}

.radio_container .round {
  height: 30px;
  width: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.radio_container .round label {
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 50%;
  height: 15px;
  left: 0;
  /*position: absolute;*/
  position: relative;
  top: 0;
  width: 15px;
}

.options_anchor {
  position: relative;
  width: 100%;
}

.options_container {
  display: none;
  position: absolute;
  top: -30px;
  left: -15px;
  background-color: white;
  width: 8rem;
  z-index: 10;
  text-align: left;
}

.radio_container:not(.no_hover):hover .round {
  opacity: 0;
}

.radio_container:not(.no_hover):hover .options_container {
  display: block;
  width: 100%;
  text-align: center;
  top: -28px;
  left: -2px;
  background-color: rgba(0,0,0,0);
}

.radio_container:not(.no_hover):hover .options_container .round{
  opacity: 1;
}

ul {
  font-size: 10px;
}

ul {
  display: inline-flex;
  margin: 0;
  padding: 0;
  list-style: none;
}

ul li  {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 4px;
}

ul li .round {
  height: 15px !important;
}

.radio_container:not(.no_hover) ul li:not(.selected):hover {
  cursor: pointer;
  color: lightgrey;
}

.radio_container:not(.no_hover) ul li:not(.selected):hover .round label {
  cursor: pointer;
  border: 2px solid lightgrey;
}

ul li.selected {
  color: lightblue;
}

ul li.selected .round label{
  border: 2px solid lightblue;
}
</style>